/* The engagement score's vocabulary, in one place.

   ★ Two screens draw a rule now — the roster's per-person breakdown on `/engagement` and the
   weights editor on `/engagement/rules` — and a signal that carries a clapping icon on one and a
   star on the other is the kind of drift nobody notices until a customer asks why. One module,
   imported by both. */

export const FAMILY_ICONS = {
  showing_up: 'check',
  saying: 'comment',
  missions: 'flag',
  answering: 'list-check',
  bringing: 'user-add',
  curious: 'bulb',
  recognition: 'hands-clapping',
  tags: 'label',
};

/* A tag rule carries the tag itself; there is no translation key for a word the company invented,
   so it is shown as the company wrote it. */
export const ruleLabel = (rule, t) => (rule.tag ? `#${rule.tag}` : t(`signal_${rule.signal}`));
